import Products from './Products';
import './css/categories.css';

function CategoriesPage(){
    return(
        <>
            <Products />
            <Products />
            <Products />
            <Products />

        </>
    )
}

export default CategoriesPage;